var React = require('react');

function Logo1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M78.8807 10C98.0522 10 113.594 25.5415 113.594 44.7129V105.971H78.8807V10Z","fill":"#262626","key":0}),React.createElement("path",{"d":"M71.2234 70.2368C66.5978 70.2368 62.0175 71.1478 57.744 72.918C53.4705 74.6881 49.5875 77.2827 46.3167 80.5535C43.0459 83.8243 40.4514 87.7073 38.6812 91.9808C36.9111 96.2543 36 100.835 36 105.46C36 110.086 36.9111 114.666 38.6812 118.94C40.4514 123.213 43.0459 127.096 46.3167 130.367C49.5875 133.638 53.4705 136.232 57.744 138.002C62.0175 139.773 66.5978 140.684 71.2234 140.684L71.2234 105.46L71.2234 70.2368Z","fill":"#262626","key":1})]);
}

Logo1.defaultProps = {"width":"25","height":"25","viewBox":"0 0 150 150","fill":"none"};

module.exports = Logo1;

Logo1.default = Logo1;
